import Vue from 'vue'
import Vuex from 'vuex'
import ElementUI from 'element-ui' //饿了么插件
import VueBlu from 'vue-blu'
import moment  from 'moment'

import Distpicker from 'v-distpicker'; //省市县插件

import VueCropper from 'vue-cropper' //图片裁剪插件




/*新增  vue validator 插件*/

import axios from 'axios';



import './assets/css/base.css';
/*组件*/
import App from './App.vue';
import VueResource from 'vue-resource';
import routes from './router/index';
import VueRouter from 'vue-router';
import store from './store/store';//全局路由配置
import base from'./store/base';
/*css*/
// import 'element-ui/lib/theme-default/index.css';
import 'element-ui/lib/theme-chalk/index.css';


/*自定义组件*/
import validator from './store/validator'; //自定义正则验证
/*import JsEncrypt from 'jsencrypt/bin/jsencrypt';*/

/*Vue.prototype.$echarts = echarts;
Vue.prototype.$jsEncrypt = JsEncrypt;*/

//引入
import echarts from 'echarts'

import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
Vue.use(mavonEditor)

Vue.prototype.$echarts = echarts


Vue.use(validator);
Vue.use(base)
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(ElementUI)
Vue.use(Vuex)


Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios



Vue.use(VueBlu)
Vue.use(moment)
Vue.use(VueCropper)
Vue.component('vueCropper', VueCropper)
Vue.component('v-distpicker', Distpicker)
Vue.config.debug = true;
//http全局配置
Vue.http.options.xhr = {withCredentials: true} //解决跨域

Vue.http.options.emulateJSON = true;

Vue.http.options.emulateHTTP = true;

Vue.http.interceptors.push((request, next) => {
    // console.log(request.headers)
    request.credentials = true
    request.headers['X-Auth-Token'] = "45678"
    // request.headers['x-api-key'] =  'B2DKnwcToh7km2AD5OYf74twieXciEdF8ZTuGWV6'
    next(function (response) {
        return response;
    })
})

var _this = new Vue({});
//全局过滤
Vue.filter('moment', function (value, formatString) {
    formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
    return moment(value).format(formatString);
});
//路由初始化 history模式
var router = new VueRouter({
    routes: routes,
    scrollBehavior: function (to, from, savedPosition) {
        return savedPosition || {x: 0, y: 0}
    }
})

//请求拦截器
Vue.http.interceptors.push((request, next) => {
    // var access_id=;
    var params = request.body;
    // if (request.method == "POST") {
    //     params.access_id = _this.getcookie("access_id")
    //     request.body = params;
    // } else {
    //     params += "&access_id=" + _this.getcookie("access_id") + "";
    // }
    // console.log(request);
    next((response) => {//在响应之后传给then之前对response进行修改和逻辑判断。对于token时候已过期的判断，就添加在此处，页面中任何一次http请求都会先调用此处方法

        //console.log(response);

        return response;

    });
});
// Vue.http.interceptors.before =function(request, next){
//     // var access_id=;
//     debugger
//     var params=request.body;
//     if(request.method=="POST"){
//         params.access_id=_this.getcookie("access_id")
//         request.body=params;
//     }else{
//         params+="&access_id="+_this.getcookie("access_id")+"";
//     }
//     // console.log(request);
//     next((response) => {//在响应之后传给then之前对response进行修改和逻辑判断。对于token时候已过期的判断，就添加在此处，页面中任何一次http请求都会先调用此处方法
//
//         console.log("before"+ response);
//         return response;
//
//     });
// };

//路由拦截器，验证用户是否认

router.beforeEach((to, from, next) => {
    //验证用户token是否存在
    console.log("1--"+to);
    console.log(to);
    var aa = _this.getcookie("child");
    var child = JSON.parse(aa);
    //debugger
    if (to.fullPath != "/login") {
        var path = to.path
        var query = to.query
        var count = 0;
        if(child != null){
            if(child.children != undefined){
                for (var i=0;i<child.children.length;i++){
                    var url = child.children[i].url;
                    if(query.go != 'button'){

                        if(path == url){
                            next();
                        }else {
                            count++;
                        }
                    }else {
                        var button = _this.getcookie("button");
                        if(button != null && button != "null"){
                            if(path.search(button) != -1){
                                next();
                            }else {
                                count = child.children.length +2;

                            }
                            console.log(path);
                        }else {
                            count = child.children.length +2;
                        }

                    }

                }
                if(count >= child.children.length){
                    // _this.savecookie("user_token", null);
                    // _this.savecookie("access_id",  null);
                    // _this.savecookie("username_client",  null);
                    // _this.savecookie("storeId",  null);
                    // _this.savecookie("child",  null);
                    //next("/advertiseManager")
                    alert("没有此菜单的权限");
                }else {
                    //开发测试
                    if (checkOnLine == "400" && _this.isUser==1) {
                        console.log("已有用户在线" + checkOnLine);
                        alert("被迫下线，该账号在别处登录！");
                        next("/login")
                    }
                    //验证admin用户
                    /* if (_this.getcookie("is_Admin") == "1" && to.fullPath == "/index") {


                     }*/
                    else {
                        next();
                    }
                }
            }else {
                alert("没有此菜单的权限");
                next("/login")
            }

        }else {
            next();
        }

        var user_token = _this.getcookie("user_token");
        var checkOnLine = _this.getcookie("checkOnLine");
        if (user_token == null) {
            console.log("用户认证信息丢失，重新登录" + user_token)
            next("/login")
        }




    } else {

        next();
    }

})
//路由启用
const app = new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')






// WEBPACK FOOTER //
// ./src/main.js